import { render, staticRenderFns } from "./TextareaBox.vue?vue&type=template&id=0c317c0e&scoped=true&"
import script from "./TextareaBox.vue?vue&type=script&lang=js&"
export * from "./TextareaBox.vue?vue&type=script&lang=js&"
import style0 from "./TextareaBox.vue?vue&type=style&index=0&id=0c317c0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c317c0e",
  null
  
)

export default component.exports